// extracted by mini-css-extract-plugin
export default {"imageWrapper":"HJ-z","twoColumnImage":"IJ-z"};